export { default as MapmakerPrivacyPolicyPage } from "./PrivacyPolicyPage";
export { default as MapmakerRefundPolicyPage } from "./RefundPolicyPage";
export { default as MapmakerTermsOfServicePage } from "./TermsOfServicePage";
